import { VehicleNotAvailablePageLabels } from 'libs/shared-lib/interfaces';

export const VEHICLE_NOT_AVAILABLE_LABELS_DE: VehicleNotAvailablePageLabels = {
    headline: '404',
    copy: 'Die von Ihnen angeforderte Seite existiert leider nicht.',
    ctaPostText: 'Weiter zu',
};
